module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAUFJREFUOE/tk88rRFEUxz/n9IZMia0UO5uHsmJhbWFpq2yeHwtbpaZoxoK/wEKMJAt7ZWdnN4rFGBZ2rCmpiZn3jmYmmcZNNyQLZ3fr+/2ce773XOGHS2q87ZJFmpAzod2HL1BOEjJzQ3LQqq8Dd4q2hzAtEPgAgQqwH4Uy6wRunVla0wxrQhZhAqg3ai2DRIzjipGLlevFUJ6cwHzRrkzYjMvsagdjCuvAaIv4NIHMC5y3JSyoshSF0uMe+dIeBTqBG4ONuMyhppjUFKsYVSB7X+WkW5kRZVmgvwaKQvkwSSPDd2C9oRklM9aSZ45qZ21nSpUVYKD5Rt7AJlPBIBAYcWX6FeCnj/57wHzR7hB6PXfwTXYbhdLn3sMLGw8CcgZdPlARHmIjMz8oBSfQB+Krcf4IX7NL9w/8TnoN79/P8BVJr2YVVVJk/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/44.png
// module id = 88vd
// module chunks = 0